module.exports = {
  "id": "cave walls",
  "title": "cave walls",
  "image": "provision/parts/cave walls/cave walls.png",
  "info": [
    {
      "text": "Add cave walls to your project",
      "image": "provision/parts/cave walls/cave walls.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/cave walls/cave walls.png"
};